module.exports = __webpack_public_path__ + "img/06-bg.6b8aab7a.jpg";